import React, { useLayoutEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

//Layouts
import NonAuthLayout from '../Layouts/NonAuthLayout';
import VerticalLayout from '../Layouts/index';

import { UserProvider } from '../context/UserContext';
import AuthProtected from './AuthProtected';
//routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';

const Index = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname !== '/login') {
      document.title = 'MPM';
    }
  }, [location.pathname, location.search]);

  return (
    <React.Fragment>
      <UserProvider>
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}

          {/* Protected Routes */}
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
            />
          ))}

          {/* Catch all route - redirect to login if no matching route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </UserProvider>
    </React.Fragment>
  );
};

export default Index;
